import { POST } from "api/httpMethods";

export const subscribeNewsletter = (email: string, url: string) => {
  return POST(url, { params: { email } }, !url);
};

interface SubscriptionClientParams {
  name: string;
  email: string;
  phone: string;
}

export const submitSubscriptionClient = (
  params: SubscriptionClientParams,
  url: string,
) => {
  return POST(url, { params }, !url);
};
